(function(){
  const pad = n => String(n).padStart(2, '0');

  function buildMarkup(el){
    const prefix = el.dataset.prefix || 'Grading endet in';
    const badge  = el.dataset.badge  || 'Einsendeschluss';

    // Nur generieren, wenn noch keine Struktur vorhanden ist
    if (el.querySelector('.cs-time')) return;

    el.innerHTML = `
      <div class="cs-countdown__inner">
        ${badge ? `<span class="cs-badge">${badge}</span>` : ''}
        <div class="cs-line">
          ${prefix ? `<span class="cs-prefix">${prefix}</span>` : ''}
          <span class="cs-time" aria-live="polite">--T : --Std : --Min : --Sek</span>
        </div>
      </div>
    `;
  }

  function initCountdown(el){
    const parse       = str => new Date(str); // ISO mit TZ verwenden!
    const deadline    = parse(el.dataset.deadline);
    const expiredText = el.dataset.expiredText || 'Einsendeschluss erreicht';

    buildMarkup(el);

    const timeNode = el.querySelector('.cs-time');
    if (!timeNode || isNaN(deadline)) {
      if (timeNode) timeNode.textContent = 'Datum ungültig';
      return;
    }

    function tick(){
      const diff = deadline - new Date();
      if (diff <= 0){
        timeNode.textContent = expiredText;
        el.classList.add('cs-expired');
        clearInterval(timer);
        return;
      }
      const s   = Math.floor(diff/1000);
      const d   = Math.floor(s/86400);
      const h   = Math.floor((s%86400)/3600);
      const m   = Math.floor((s%3600)/60);
      const sec = s%60;
      timeNode.textContent = `${pad(d)}T : ${pad(h)} Std : ${pad(m)} Min : ${pad(sec)} Sek`;
    }

    tick();
    const timer = setInterval(tick, 1000);
  }

  function boot(root){
    (root || document).querySelectorAll('.cs-countdown').forEach(initCountdown);
  }

  document.addEventListener('DOMContentLoaded', ()=> boot());
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();